module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.customer) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-box",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-no-bg",
    attrs: {
      "default-active": _vm.tabs.default,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleTabs
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "summary"
    }
  }, [_vm._v("Vue d'ensemble")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "services_documents"
    }
  }, [_vm._v("Services & Documents")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "emails"
    }
  }, [_vm._v("Emails")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "empty"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Liaisons")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "devis-b2b"
    }
  }, [_vm._v("Devis B2B\n              "), (_vm.customer.sources['devis-b2b']) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Modifier")]) : _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Créer")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "communication"
    }
  }, [_vm._v("Communication\n              "), (_vm.customer.sources['communication']) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Modifier")]) : _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Créer")])])], 2)], 1)], 1)])]), _vm._v(" "), (_vm.tabs.active === 'summary') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-lg-3"
  }, [_c('customer-informations-summary-widget', {
    attrs: {
      "customer": _vm.customer
    }
  }), _vm._v(" "), _c('customer-contacts-summary-widget', {
    attrs: {
      "customer": _vm.customer
    }
  }), _vm._v(" "), _c('customer-administration-summary-widget', {
    attrs: {
      "customer": _vm.customer
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-6"
  }, [_c('customer-timeline-summary-widget', {
    attrs: {
      "customer": _vm.customer,
      "relations": _vm.relations,
      "interface": 'COMMERCIAL'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-3"
  }, [_c('customer-billing-summary-widget', {
    attrs: {
      "customer": _vm.customer
    }
  }), _vm._v(" "), _c('customer-services-summary-widget', {
    attrs: {
      "customer": _vm.customer
    },
    on: {
      "show": _vm.handleShow
    }
  }), _vm._v(" "), _c('customer-propositions-summary-widget', {
    attrs: {
      "customer": _vm.customer,
      "relations": _vm.relations
    },
    on: {
      "show": _vm.handleShow
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-box"
  }, [_c('h4', {
    staticClass: "header-title m-t-0 m-b-20"
  }, [_vm._v("Liaisons")]), _vm._v(" "), _c('ul', {
    staticClass: "ul-fa"
  }, [(_vm.customer.sources['devis-b2b']) ? _c('li', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Devis B2B")]) : _c('li', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Devis B2B")]), _vm._v(" "), (_vm.customer.sources['communication']) ? _c('li', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Communication\n          ")]) : _c('li', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Communication")]), _vm._v(" "), (_vm.customer.sources['sellsy-comweb']) ? _c('li', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Sellsy ComWeb\n          ")]) : _c('li', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Sellsy ComWeb")])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.tabs.active === 'services_documents') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('services-and-documents', {
    attrs: {
      "customer": _vm.customer,
      "relations": _vm.relations
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.tabs.active === 'emails') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('emails', {
    attrs: {
      "customer": _vm.customer,
      "relations": _vm.relations
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.tabs.active === 'devis-b2b') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.iframe.loading),
      expression: "iframe.loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('iframe', {
    style: ({
      width: '100%',
      height: _vm.iframe.size + 'px',
      border: 0
    }),
    attrs: {
      "src": _vm.getCustomerUrl('devis-b2b')
    },
    on: {
      "load": _vm.iframeLoaded
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "left": "100px",
      "bottom": "40px",
      "background": "white",
      "padding": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.getCustomerUrl('devis-b2b'),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Ouvrir dans un nouvel onglet")])])]) : _vm._e(), _vm._v(" "), (_vm.tabs.active === 'communication') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.iframe.loading),
      expression: "iframe.loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('iframe', {
    style: ({
      width: '100%',
      height: _vm.iframe.size + 'px',
      border: 0
    }),
    attrs: {
      "src": _vm.getCustomerUrl('communication')
    },
    on: {
      "load": _vm.iframeLoaded
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "left": "100px",
      "bottom": "40px",
      "background": "white",
      "padding": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.getCustomerUrl('communication'),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Ouvrir dans un nouvel onglet")])])]) : _vm._e()]) : _c('div', {
    staticClass: "content-loading",
    attrs: {
      "v-loading": true
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94e9a67c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents/Main/Customers.vue
// module id = 717
// module chunks = 1